/**
 * File ga-cookie-validator.js.
 * Validates size of gclid in Google Ads cookies to prevent cookie overload
 */

const gaCookies = [
  '_gcl_aw',
  '_gac_UA-62152209-7'
];

const gclidMaxSize = 100; // SEE: https://support.google.com/analytics/answer/2938246#troubleshooting

function byteCount(s) {
  return encodeURI(s).split(/%..|./).length - 1;
}

function removeCookie(name) {
  document.cookie = name +'=;expires=-1;domain=' + globalCookieDomain + ';path=/;';
}

function validateGaCookies() {
  for (let i = 0; i < gaCookies.length; i++) {
    const n = gaCookies[i];
    const v = getCookieValue(n);
    const gclid = v.split('.')[2];
  
    if (byteCount(gclid) > gclidMaxSize) removeCookie(n);
  }
}

// Init
window.addEventListener('load', validateGaCookies);
